import styled from '@emotion/styled';
import { Colors } from '../../../../colors';

export const SearchBarStyled = {
  Container: styled.div<any>`
    padding: 5px 15px 0px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${Colors.UnderlinedGrey};
  `,
  ContainerEdit: styled.div<any>`
    flex-grow: 1;
  `,
};
